import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import { Form } from 'react-bootstrap';

import ValidationAlert from '../../../app/components/ValidationAlert';
import FormRow from '../../../app/components/FormRow';
import { CreateUpdateExamTypeCategoryDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/CreateUpdateExamTypeCategoryDto';
import LastEditorInfo from '../../../app/components/LastEditorInfo';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

interface ExamTypeCategoryEditorProps {
  id?: string;
  examTypeCategory: CreateUpdateExamTypeCategoryDto;
  handleClose?: () => void;
  show?: boolean;
  onCompleted: (
    examTypeCategory: CreateUpdateExamTypeCategoryDto,
    id?: string,
  ) => Promise<{
    saved: boolean;
    errors: string[];
  }>;
}

export const ExamTypeCategoryEditor: React.FC<
  ExamTypeCategoryEditorProps
> = props => {
  const [examTypeCategory, setExamTypeCategory] = useState(
    props.examTypeCategory,
  );
  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const [saveErrors, setSaveErrors] = useState<string[]>([]);

  const spd = useSpdCore();

  useEffect(() => {
    if (props.show) {
      setSaveErrors([]);
      setShowSaveErrors(false);
      setExamTypeCategory(props.examTypeCategory);
    }
  }, [props.show, props.examTypeCategory, props.id]);

  const createExamTypeCategory = async () => {
    props
      .onCompleted(examTypeCategory, props.id)
      .then(saveStatus => {
        if (!saveStatus.saved) {
          setSaveErrors(saveStatus.errors);
          setShowSaveErrors(true);
          return;
        }
      })
      .catch(error => {
        setSaveErrors(error);
        setShowSaveErrors(true);
      });
  };

  const propertyChange = (obj: Partial<CreateUpdateExamTypeCategoryDto>) => {
    setExamTypeCategory({ ...examTypeCategory, ...obj });
  };

  return (
    <>
      <Modal
        onHide={props.handleClose}
        show={props.show}
        centered={true}
        keyboard={true}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {props.id
              ? 'Edycja kategorii typów badań'
              : 'Dodawanie nowej kategorii typów badań'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card className="mb-2">
            <Card.Header>Kategoria typów badań</Card.Header>
            <Card.Body>
              <Form className="d-grid gap-3">
                <FormRow controlId="name" label="Nazwa">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={examTypeCategory?.name || ''}
                    onChange={e => propertyChange({ name: e.target.value })}
                  />
                </FormRow>
                <FormRow controlId="active" label="Aktywny">
                  <Form.Check
                    type="checkbox"
                    checked={examTypeCategory?.active ? true : false}
                    onChange={e => propertyChange({ active: e.target.checked })}
                  />
                </FormRow>
              </Form>
            </Card.Body>
          </Card>
          <ValidationAlert
            show={showSaveErrors}
            errors={saveErrors}
            className="mt-3"
          />
        </Modal.Body>
        <Modal.Footer>
          {props.id && (
            <LastEditorInfo
              id={props.id}
              method={spd.examTypesCategories.getLastEditor}
            />
          )}
          <Button variant="outline-secondary" onClick={props.handleClose}>
            Zamknij
          </Button>
          <Button variant="outline-primary" onClick={createExamTypeCategory}>
            Zapisz
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
